<template>
  <div class="payment-success-container">
    <v-card class="payment-success-card" elevation="2">
      <v-card-text class="text-center py-8">
        <v-icon size="80" color="success" class="mb-4">
          mdi-check-circle
        </v-icon>
        <h1 class="text-h4 font-weight-bold mb-4">Payment Successful!</h1>
        <p class="text-body-1 mb-6 font-weight-medium">
          Your payment has been processed successfully
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  methods: {
    goHome() {
      this.$router.push('/tourist')
    },
  },
}
</script>

<style scoped>
.payment-success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.payment-success-card {
  max-width: 500px;
  width: 100%;
}
</style>
